import { render } from "./DashMenu.vue?vue&type=template&id=6d924048&scoped=true"
import script from "./DashMenu.vue?vue&type=script&lang=js"
export * from "./DashMenu.vue?vue&type=script&lang=js"

import "./DashMenu.vue?vue&type=style&index=0&id=6d924048&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d924048"]])

export default __exports__